import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { catchError } from "rxjs/operators";
import { throwError as observableThrowError } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class LocationService {
	public static readonly PERMISSION_DENIED = 1;
	public static readonly UNSUPPORTED_BROWSER = -1;

	getLocation(): Observable<any> {
		return new Observable(x => {
			if (window.navigator && window.navigator.geolocation) {
				window.navigator.geolocation.getCurrentPosition(
					result => {
						x.next(result);
						x.complete();
					},
					err => x.error(err),
					{ enableHighAccuracy: true, timeout: 5000 }
				);
			} else {
				x.error({ code: LocationService.UNSUPPORTED_BROWSER, message: 'Unsupported Browser!' });
			}
		});
	}

	getDistace(lat1, lon1, lat2, lon2) {
		const R = 6371; // km
		const dLat = this.toRad(lat2 - lat1);
		const dLon = this.toRad(lon2 - lon1);
		const lat1Rad = this.toRad(lat1);
		const lat2Rad = this.toRad(lat2);

		let a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
			Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1Rad) * Math.cos(lat2Rad);
		let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
		let d = R * c;
		return d;
	}

	// Converts numeric degrees to radians
	toRad(value) {
		return value * Math.PI / 180;
	}
}
